import React from 'react';
import RoleForm from './RoleForm';
import StandardModal from '../../Shared/UI/StandardModal/components/StandardModal';
import { useRoleIndexState, useRoleIndexActions } from './RoleIndexContext';
import { createRole } from './restApi';

import styles from './RoleModal.module.scss';

const RoleModal = () => {
  const state = useRoleIndexState();
  const { closeRoleModal, onResponse, onError } = useRoleIndexActions();

  return (
    <StandardModal
      isOpen={state?.roleModalIsOpen}
      onRequestClose={() => {
        closeRoleModal();
      }}
    >
      <section className={styles.section}>
        <h2 className={styles.sectionTitle}>
          Create Role
        </h2>
        <RoleForm
          onSubmit={(args) => {
            createRole({
              ...args,
              onResponse,
              onError,
            });
          }}
          onCancel={closeRoleModal}
        />
      </section>
    </StandardModal>
  );
};

export default RoleModal;
